import { DTOGetQualityUserBadgeDetailRequest } from 'src/apis/dto/DTOGetQualityUserBadgeDetailRequest';
import { DTOGetQualityUserBadgeDetailResponse } from 'src/apis/dto/DTOGetQualityUserBadgeDetailResponse';
import { RestQueryOptions, useRestQuery } from 'src/hooks/useRestQuery';
export enum QualityUserBadgeApiList {
  GetDetails = '/rating-service/v1/details/quality-user-badges',
}
export const useGetQualityUserBadgeDetailsQuery = (params: DTOGetQualityUserBadgeDetailRequest, options: RestQueryOptions<DTOGetQualityUserBadgeDetailResponse> = {}) => {
  return useRestQuery<DTOGetQualityUserBadgeDetailRequest, DTOGetQualityUserBadgeDetailResponse, void>({
    path: QualityUserBadgeApiList.GetDetails,
    params,
    options: {
      ...options,
      /**
       * 아자르 뱃지 관련 메타 정보는 한 번 가져온 후 쭉 캐싱해서 사용
       * (한 번 받아온 후 해당하는 뱃지 상태에 맞는 정보를 뽑아쓰는 방식)
       */
      gcTime: Infinity,
      staleTime: Infinity
    }
  });
};